import { Directive, inject, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { KeplerSfdcService } from '@services';
import { combineLatest, Subscription, tap } from 'rxjs';

/**
 * Structural directive to place on components that should only be shown to designated approvers. Specifically for User Management
 *
 * @example
 * <p *designatedApprover>
 *   hello, {{ user.name }}! You are a designated approver!
 * </p>
 */
@Directive({
    selector: '[designatedApprover]',
    standalone: true,
})
export class DesignatedApproverDirective implements OnInit, OnDestroy {
    private sub: Subscription;
    private salesforce = inject(KeplerSfdcService);
    private templateRef = inject(TemplateRef<any>);
    private viewContainer = inject(ViewContainerRef);

    ngOnInit(): void {
        this.sub = combineLatest([this.salesforce.userDetailsRecord$, this.salesforce.isCoreTeam$])
            .pipe(
                tap(([sfdcDetails, isCoreTeam]) => {
                    this.viewContainer.clear();
                    if (isCoreTeam || sfdcDetails.IsCCApprover) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                    }
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }
}
